import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DateFormatPipe } from '../pipes/dateFormat.pipe';
import { forkJoin, Observable } from 'rxjs';
// import { Observable } from 'rxjs/Rx';


const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});


@Injectable()
export class HealthService {
  healthData: any = {};

  healthArray = [

    // {'name': 'Unhealthy', 'value': '', 'description': '',
    //  'className': 'fa fa-heartbeat', 'spanClass': 'label label-warning pull-right', 'infoClass': 'info-box-icon bg-aqua'},
    {'name': 'CRITICAL', 'value': '', 'description': '',
     'className': 'fa fa-ambulance', 'spanClass': 'label label-danger pull-right', 'infoClass': 'info-box-icon bg-red'},
    // {'name': 'Timeout', 'value': '', 'description': '',
    //  'className': 'fa fa-hourglass-end', 'spanClass': 'label label-info pull-right', 'infoClass': 'info-box-icon bg-coral'},
    {'name': 'WARNING', 'value': '', 'description': '',
     'className': 'fa fa-bell', 'spanClass': 'label label-warning pull-right', 'infoClass': 'info-box-icon bg-yellow'},
    {'name': 'UNKNOWN', 'value': '', 'description': '',
     'className': 'fa fa-question', 'spanClass': 'label label-info pull-right', 'infoClass': 'info-box-icon bg-coral'},
    {'name': 'NORMAL', 'value': '', 'description': '',
     'className': 'fa fa-smile-o', 'spanClass': 'label label-success pull-right', 'infoClass': 'info-box-icon bg-green'}
  ];

  countUrl = '/superadmin/rest/mgmt/health/count?';
  healthUrl = '/superadmin/rest/mgmt/health?';
  healthConfig = '/superadmin/rest/mgmt/health/config';
  healthDetailsUrl = '/superadmin/rest/mgmt/health/hour';
  healthStatusCount = '/superadmin/rest/mgmt/health/status';
  healthComponents = '/superadmin/rest/mgmt/health/components';
  anhourHealthdata = '/superadmin/rest/mgmt/health/hour';
  healthStatusUrl = '/superadmin/rest/mgmt/health/status';
  healthComponentData: any[];
  criticalCount: number;
  warningCount: number;
  normalCount: number;
  unknownCount: number;
  constructor(private http: HttpClient, private datepipe: DateFormatPipe) { }


gethealthInfo(
  filter , sortOrder,
  pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.healthUrl + filter, {
      params: new HttpParams()
          .set('asc', sortOrder)
          .set('from', pageNumber.toString())
          .set('count', pageSize.toString())
  });

}

setFilterParam() {
 const dateTime: any = {};
  const currentTime = this.datepipe.transform(new Date());
  const prevdate = new Date();
  prevdate.setHours(prevdate.getHours() - 1);
  const previousTime = this.datepipe.transform(prevdate);
   const firstDate = this.datepipe.transformTOWords(prevdate);
  const secondDate = this.datepipe.transformTOWords(new Date());
  const filterparam = 'createdDate-ge=' + previousTime + '&createdDate-le=' + currentTime;
  dateTime.currentTime = currentTime;
  dateTime.previousTime = previousTime;
  dateTime.firstDate = firstDate;
  dateTime.secondDate = secondDate;
  dateTime.filterparam = filterparam;
  return dateTime;
}
// getHealthResult(filterparam): Observable<any> {
//   const unhealthy = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=unhealthy&queryType=AND', {headers});
//  const timeout = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=timeout&queryType=AND', {headers});
//  const warning = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=warning&queryType=AND', {headers});
//  const normal = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=normal&queryType=AND', {headers});
//  const critical = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=critical&queryType=AND', {headers});
//  const unknown = this.http.get(this.countUrl + filterparam + '&healthStatusType-eq=unknown&queryType=AND', {headers});
//  const request = {
//   'unhealthy': unhealthy,
//   'timeout': timeout,
//   'warning': warning,
//   'normal': normal,
//   'critical': critical,
//   'unknown': unknown
//  }
//  return forkJoin([request['unhealthy'], request['critical'], request['timeout'], request['warning'], request['unknown'], request['normal']]);
// //  return forkJoin([unhealthy, critical, timeout, warning, unknown, normal])
// //  .subscribe(responses => {
// //     return [].concat(...responses);
// //  });
// }

// getHealthInfo(request) {
//     forkJoin([request['unhealthy'], request['critical'], request['timeout'], request['warning'], request['unknown'], request['normal']]).subscribe(
//       (response: any)=> {
//         // resolve(response);
//       },
//       ()=> {
//         // resolve([]);
//       }
//      )
//   // })
// }

getHealthcount(): Observable<any> {
  return this.http.get ('./assets/health_status.json');
}

/**Fetch Config data of health */
getHealthConfig(): Observable<any> {
  return this.http.get(this.healthConfig, {headers});
}

getTotalFilterCount(filter): Observable<any> {
  return this.http.get(this.countUrl + filter, {headers});
}
getHealthResultByStatus(filterparam) {

  return this.http.get(this.healthUrl + filterparam + '&from=0&count=10&asc=false&queryType=AND', {headers});
}
getHealthDetailsById(healthId, sourceId): Observable<any> {
  return this.http.get(this.healthComponents + '/' + sourceId + '/' + healthId);
}
getComponentOnehourData(compId, sourceId ): Observable<any> {
  return this.http.get(this.anhourHealthdata + '/' + sourceId + '/' + compId);
}
getComponentDetails(compId, sourceId): Observable<any> {
  return this.http.get(this.healthComponents + '/' + sourceId + '/' + compId, { headers: headers});
}

storeHealthData(data) {
  this.healthData = data;

}
getHealthComponents(): Observable<any> {
  return this.http.get(this.healthComponents, {headers} );
}
getHealthStatus(): Observable<any> {
  return this.http.get(this.healthStatusUrl,  {headers});

}
getStatusEvery2Secs(compId, sourceId): Observable<any> {
 // return this.http.get('./assets/health2sec.json');
 return this.http.get(this.healthStatusUrl + '/' + sourceId + '/' + compId, {headers: headers});

}
// getTest2sec(): Observable<any> {
//   return this.http.get('./assets/test2sec.json');

// }

groupDatabySourceName(data) {

  const groups = new Set(data.map(comp => comp.sourceId));
  const healthDataCompArray = [];
  groups.forEach(function (group) {
    healthDataCompArray.push({
      name: group,
      values: data.filter(i => i.sourceId === group)
    });
  });
  this.healthComponentData = healthDataCompArray;

}
getHealthComponentData() {
  return this.healthComponentData;
}
getHealthStatusCount(data) {
  this.criticalCount = 0;
    this.warningCount = 0;
    this.normalCount = 0;
    this.unknownCount = 0;

    data.forEach(component => {

      if (component.clusterStatus) {
        const isCritical = component.clusterStatus.find(comp => comp.status === 'CRITICAL');
        if (isCritical) {
          this.criticalCount = this.criticalCount + 1;
          return;
        } else {
          const isWarning = component.clusterStatus.find(comp => comp.status === 'WARNING');
          if (isWarning) {
            this.warningCount = this.warningCount + 1;
            return;
          } else {
            const isUnknown = component.clusterStatus.find(comp => comp.status === 'UNKNOWN');
            if (isUnknown) {
              this.unknownCount = this.unknownCount + 1;
              return;
            } else {
              const isNormal = component.clusterStatus.find(comp => comp.status === 'NORMAL');
              if (isNormal) {
                this.normalCount = this.normalCount + 1;
                return;
              }
            }
          }
        }
      }

    });
    this.healthArray.forEach(health => {
      if ( health.name === 'CRITICAL') {
        health.value = this.criticalCount.toString();
        return;
      }
      if (health.name === 'WARNING') {
        health.value  = this.warningCount.toString();
        return;
      }
      if (health.name === 'UNKNOWN') {
        health.value = this.unknownCount.toString();
        return;
      }
      if (health.name === 'NORMAL') {
        health.value = this.normalCount.toString();
        return;
      }

    });

  }

}



